import { render, staticRenderFns } from "./BaseSlider.vue?vue&type=template&id=77808c42&"
import script from "./BaseSlider.vue?vue&type=script&lang=js&"
export * from "./BaseSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77808c42')) {
      api.createRecord('77808c42', component.options)
    } else {
      api.reload('77808c42', component.options)
    }
    module.hot.accept("./BaseSlider.vue?vue&type=template&id=77808c42&", function () {
      api.rerender('77808c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseSlider.vue"
export default component.exports